var getWeekday = function (date, lng) {
    var dateString = date.toLocaleDateString(lng, { weekday: 'long' });
    if (lng === 'he-IL')
        dateString = dateString.split(' ')[1];
    return dateString;
};
export default getWeekday;
//# sourceMappingURL=getWeekday.js.map